import Identity from "./Identity.model";
import CustomerDependant from "./CustomerDependant.model";
export default class Customer {
    constructor() {
        this.id;
        this.identityId;
        this.customerCompanyId;
        this.cardNumber;
        this.applicationFormFileId;
        this.consentFormFileId;
        this.isDeleted;
        this.createdAt;
        this.modifiedAt;
        this.bankName;
        this.bankBranchCode;
        this.bankAccountNumber;
        this.bankAccountType;
        this.createdByUserId;
        this.signedUpByUserId;
        this.subscriptionId;
        this.customerStatus = 0;
        this.welcomeEmailSentAt;
        this.welcomeSmsSentAt;
        this.identity;
        this.dependants;
        this.debitOrderDate;
        this.commencementDate;
        this.notes;
        this.consentSms;
        this.personResponsibleName;
        this.personResponsibleContactInfo;
        this.emergencyContactNumber;
        this.welcomeSms;

        this.customerStatusCompany = 0;
        this.customerStatusIndividual = 0;
        this.brokerId;
        this.accountNumber;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.debitOrderDate = setEntity.debitOrderDate;
        this.commencementDate = setEntity.commencementDate;
        this.identityId = setEntity.identityId;
        this.customerCompanyId = setEntity.customerCompanyId;
        this.cardNumber = setEntity.cardNumber;
        this.applicationFormFileId = setEntity.applicationFormFileId;
        this.consentFormFileId = setEntity.consentFormFileId;
        this.isDeleted = setEntity.isDeleted;
        this.createdAt = setEntity.createdAt;
        this.modifiedAt = setEntity.modifiedAt;
        this.bankName = setEntity.bankName;
        this.bankBranchCode = setEntity.bankBranchCode;
        this.bankAccountNumber = setEntity.bankAccountNumber;
        this.bankAccountType = setEntity.bankAccountType;
        this.createdByUserId = setEntity.createdByUserId;
        this.signedUpByUserId = setEntity.signedUpByUserId;
        this.subscriptionId = setEntity.subscriptionId;
        this.customerStatus = setEntity.customerStatus;
        this.welcomeEmailSentAt = setEntity.welcomeEmailSentAt;
        this.welcomeSmsSentAt = setEntity.welcomeSmsSentAt;
        this.personResponsibleName = setEntity.personResponsibleName;
        this.personResponsibleContactInfo = setEntity.personResponsibleContactInfo;
        this.emergencyContactNumber = setEntity.emergencyContactNumber;
        this.welcomeSms = setEntity.welcomeSms;
        this.customerStatusCompany = setEntity.customerStatusCompany;
        this.customerStatusIndividual = setEntity.customerStatusIndividual;
        this.identity = setEntity.identity ? new Identity().set(setEntity.identity) : new Identity();
        this.dependants = [];
        if (setEntity.dependants)
            setEntity.dependants.forEach((x) => {
                this.dependants.push(new CustomerDependant().set(x));
            });
        this.notes = setEntity.notes ? setEntity.notes : [];
        this.consentSms = setEntity.consentSms;
        this.brokerId = setEntity.brokerId;
        this.accountNumber = setEntity.accountNumber;
        return this;
    }
}
